var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28402_22791)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26917 0.864258C6.64235 0.864258 6.94485 1.16677 6.94485 1.53993V4.91831C6.94485 5.29149 6.64235 5.59399 6.26917 5.59399C5.896 5.59399 5.5935 5.29149 5.5935 4.91831V3.9048H3.56647C2.82014 3.9048 2.21512 4.50983 2.21512 5.25615V6.94534H19.7827V5.25615C19.7827 4.50983 19.1777 3.9048 18.4313 3.9048H17.4178V2.55345H18.4313C19.924 2.55345 21.134 3.76348 21.134 5.25615V18.4318C21.134 19.9245 19.924 21.1345 18.4313 21.1345H3.56647C2.07381 21.1345 0.86377 19.9245 0.86377 18.4318V7.62101V5.25615C0.86377 3.76348 2.07381 2.55345 3.56647 2.55345H5.5935V1.53993C5.5935 1.16677 5.896 0.864258 6.26917 0.864258ZM2.21512 8.29669V18.4318C2.21512 19.1781 2.82014 19.7832 3.56647 19.7832H18.4313C19.1777 19.7832 19.7827 19.1781 19.7827 18.4318V8.29669H2.21512Z",
    fill: "#AFAFBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7288 0.864258C16.1019 0.864258 16.4044 1.16677 16.4044 1.53993V4.91831C16.4044 5.29149 16.1019 5.59399 15.7288 5.59399C15.3556 5.59399 15.0531 5.29149 15.0531 4.91831V3.9048H7.9585V2.55345H15.0531V1.53993C15.0531 1.16677 15.3556 0.864258 15.7288 0.864258Z",
    fill: "#AFAFBB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28402_22791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6216,
    height: 21.6216,
    fill: "white",
    transform: "translate(0.188965 0.189209)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.820c541984b03fb08ac77a16fc83e53f.svg";
export { ForwardRef as ReactComponent };